import moment from "moment";
import { NotificationManager } from "react-notifications";

// import Config from "../../../../config";
// import { USER_PROFILE_STATUS } from "../../../../static-data";
import GenericApi from "../../../../services/generics";

// const { CURRENT_PLATFORM, PLATFORMS } = Config;
// const NEW_PRICING_PACKAGES = ["2m_basic", "3m_basic", "3m_pro", "6m_vip"];

// export const determinePricingPackages = ({
//   adStatus,
//   selectedPackage,
//   appConfig,
//   pricingTier,
// }) => {
//   if (CURRENT_PLATFORM === PLATFORMS.IN) {
//     return false;
//   }
//   const pricingConfig =
//     (Array.isArray(appConfig.appConfig) ? appConfig.appConfig : []).find(
//       (ele) => ele.id === "new_pricing"
//     ) ?? {};
//   const newPricingEnabled = pricingConfig?.enabled ?? false;

//   switch (adStatus) {
//     case USER_PROFILE_STATUS.PAYMENT_PENDING:
//       return newPricingEnabled;
//     case USER_PROFILE_STATUS.IN_REVIEW:
//       return NEW_PRICING_PACKAGES.includes(selectedPackage);
//     case USER_PROFILE_STATUS.LIVE:
//     case USER_PROFILE_STATUS.EXPIRED:
//       return NEW_PRICING_PACKAGES.includes(pricingTier?.id);
//     default:
//       return false;
//   }
// };

export const getUploadedFileId = async ({
  setLoading,
  uploadedPaymentProof,
}) => {
  const formData = new FormData();
  formData.append("file", uploadedPaymentProof);
  const response = await GenericApi.genericUpload({ formData });

  if (!response.success) {
    NotificationManager.error(
      "Upload failed. Please ensure the file is a valid image or PDF.",
      "Error"
    );
    setLoading(false);
    return null;
  }
  return response.body?.name ?? null;
};

export const downloadPaymentSlip = ({ blob, paymentDate, adId }) => {
  if (!blob || !(blob instanceof Blob)) return;

  const url = URL.createObjectURL(blob);

  const contentType = blob?.type ?? "";
  const extension =
    contentType && contentType.includes("/")
      ? contentType.split("/")[1]
      : "bin";

  const date = moment(paymentDate).local().format("YYYY-MM-DD");

  const link = document.createElement("a");
  link.href = url;
  link.download = `Ad_${adId}_${date}.${extension}`;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
